import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Master } from 'src/app/models/Master';
import { UtilityTs } from 'src/app/util/utilityTs';

import { BackEndService } from '../backEnd.service';

@Injectable({
  providedIn: 'root',
})
export class MasterService {
  masterType: string[] = ['area', 'caste'];
  areaMaster: string[] = ['country', 'state', 'district', 'location'];
  casteMaster: string[] = ['religion', 'caste', 'community', 'sub_community'];
  master: Master = new Master;
  masterList: Master[] = [];
  masterMap: Map<string, Master[]> = new Map();

  area: Master = new Master;
  areaList: Master[] = [];

  constructor(private backEnd: BackEndService) {
  }

  updateMaster(name, category) {
    let query = [["category", category]];
    if (name) {
      let exist;
      if (category == 'area') {
        exist = this.areaList.find(x => x.name == name);
      } else {
        exist = this.masterList.find(x => x.name == name);
      }

      if (exist) {
        query.push(["parent_id", exist.name])
      }
    } else {
      query.push(["level", 1])
    }

    this.backEnd.searchObject(appConfig.STORAGE_TABLE.MASTER, query).then((masterList: Master[]) => {
      if (category == 'area') {
        this.areaList = UtilityTs.mergeArrays(this.areaList, masterList, "id");
      } else {
        this.masterList = UtilityTs.mergeArrays(this.masterList, masterList, "id");
      }
    })
  }


  getLevel(level, category) {
    if (category == 'area') {
      return this.areaList.filter(x => x.level == level);
    } else {
      return this.masterList.filter(x => x.level == level);
    }
  }

  getMaster(name, level?) {
    return new Promise((resolve) => {
      if (name) {
        let query = [['name', name]];
        if (level) {
          query.push(['level', level])
        }
        this.backEnd.getSingle(appConfig.STORAGE_TABLE.MASTER, query).then((master: Master) => {
          resolve(master)
        })
      } else {
        resolve(null);
      }
    })

  }

  searchMaster(query) {
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.MASTER, query, null, 1000, "name").then((masterList: Master[]) => {
        resolve(masterList);
      })
    })

  }

  async saveMaster(master) {
    return await this.backEnd.saveObject("master", master);
  }

  async deleteMaster(master) {
    return await this.backEnd.deleteObject("master", master.id)
  }

}
